const PRELOAD_OPTIONS_LIMIT = 200;
const PRELOAD_OPTIONS_SEARCH = 2000;

const preloadOptionsLimit = () => PRELOAD_OPTIONS_LIMIT;

const preloadOptionsSearch = () => PRELOAD_OPTIONS_SEARCH;

export { preloadOptionsLimit, preloadOptionsSearch };